import AppConstant from '../../../../config/app.constants';

class StopPerformance {
    /*@ngInject*/

    constructor(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, UsersService, UserBranchService,
        RouteStopService, DataCounter, $state, Navigation, RouteService, $rootScope) {
        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.RouteStopService = RouteStopService;
        this.RouteService = RouteService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.$q = $q;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            stopPerformanceObj: {
                loading: false,
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
            },
            routeListObj: {
                loading: false,
                results: [],
                totalRecords: 0
            },
            loggedInUser: User.getUser().id,
            branch: User.getUser().branchId,
            userBranchList: [],
            timezone: null,
            sortColumn: "countedAt",
            reverseSort: true,
            isExporting: false,
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            }
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/stop-performance');
        this.initialSearchFocusApplied = false;
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.UsersService.getUserFieldData(this.model.loggedInUser),
            this.UserBranchService.getUserBranches(this.model.loggedInUser),
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.userDetails = data[1];
                this.model.userBranchList = data[2].results;
                this.model.vaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);
                this.model.timezone = (this.model.userDetails && this.model.userDetails.timezone) ? this.model.userDetails.timezone : moment.tz.guess();

                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                })

                this.setDateRangeOptions('dateRangPickerOptionsfor');
                this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

                this.loadData();
                this.getRouteList();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    loadData() {
        this.model.stopPerformanceObj.pagination.page = 1;
        this.getStopPerformance();
    }

    getStopPerformance() {
        setTimeout(() => {
            const branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
            const routeId = this.model.routeId ? this.model.routeId.Value : null;
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();

            this.model.stopPerformanceObj.loading = true;
            this.RouteStopService.stopPerformance(this.model.searchText, null, null, branches, this.reverseSort, this.sortColumn, routeId, this.model.timezone,
                (this.model.stopPerformanceObj.pagination.page - 1) * this.model.stopPerformanceObj.pagination.pageLimit,
                this.model.stopPerformanceObj.pagination.pageLimit, startDate, endDate)
                .then((data) => {
                    this.model.stopPerformanceObj.pagination.total = data.total;
                    this.model.stopPerformanceObj.results = data.results;
                    this.model.stopPerformanceObj.totalRecords = data.total;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.stopPerformanceObj.loading = false;
                    if (!this.initialSearchFocusApplied) {
                        this.initialSearchFocusApplied = true;
                        setTimeout(() => {
                            const el = document.getElementById('stopPerformanceSearch');
                            if (el) el.focus();
                        }, 100);
                    }
                })
        })
    }

    sortData(column) {
        this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
        this.sortColumn = column;
        this.loadData();
    }

    goToServiceHistory(locationId) {
        const obj = {
            locationId: locationId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    pageChange() {
        this.getStopPerformance();
    }

    exportData() {
        const reportPrefix = `Stop_Performance(${moment().format('YYYY-MM-DD_HH:mm')})`;
        const branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
        const routeId = this.model.routeId ? this.model.routeId.Value : null;
        const startDate = this.getStartDate();
        const endDate = this.getEndDate();

        this.model.isExporting = true;
        this.RouteStopService.exportStopPerformance(this.model.searchText, null, null, branches, this.reverseSort, this.sortColumn, routeId, 
                                                    this.model.timezone, 0, 1000, startDate, endDate)
            .then((data) => {
                this.downloadFile(reportPrefix, data.reportData);
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.isExporting = false;
            })
    }

    downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
    }

    getRouteList(searchKey, offset) {
        setTimeout(() => {
            searchKey = searchKey || '';

            const routeSearchObj = {
                queryJSON: {
                    rules: [
                        {
                            field: 'branchId',
                            condition: 'IN',
                            data: this.getSelectedBranches()
                        },
                        {
                            group: {
                                rules: [{
                                    field: 'id',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                },
                                {
                                    field: 'name',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }
                                ],
                                operator: 'OR'
                            }
                        }
                    ],
                    operator: 'AND'
                }
            };

            this.model.routeListObj.loading = true;
            return this.RouteService.all(routeSearchObj, offset, AppConstant.defaultPageLimit)
                .then((data) => {
                    if (offset === 0 || offset == undefined) {
                        this.model.routeListObj.totalRecords = data.total;
                        this.model.routeListObj.results = this.mapData(data.results);
                    } else {
                        const routes = this.mapData(data.results);
                        this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
                    }
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.routeListObj.loading = false;
                })
        });
    }

    mapData(routes) {
        return routes.map((route) => {
            return {
                Key: route.name,
                Value: route.id
            }
        });
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    resetData() {
        this.model.routeId = null;
    }

    setDateRangeOptions(modelValue) {
        this.model[modelValue] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadData();
                }
            },
            ranges: {
                'Previous Week': [
                    moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Last 60 Days': [
                    moment().subtract('59','days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
            }
        }
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
}

export default StopPerformance;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/stop_performance/stop_performance.controller.js